module.exports = __webpack_public_path__ + "img/T5-D-xh_17.c8ff5596.png";